import axios from 'axios';
import store from 'store';

const state = {
  transactions: {},
};

const getters = {
  getTransactionsFiltered: st => query => {
    axios.get(`charges?${query}`).then(res => {
      st.transactions = res.data;
    });
  },
};

const mutations = {
  setTransactions: (st, payload) => {
    st.transactions = payload;
  },
};

const actions = {
  getTransactions: ({ commit }) => {
    commit('setTransactions', {});
    if (store.get('permissions').indexOf('job-charges.index') >= 0) {
      axios.get(`charges`).then(res => {
        commit('setTransactions', res.data);
      });
    }
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./src/store/modules/transactions.js